import { Select as r } from "./Select.js";
import { Select as i } from "radix-ui";
export {
  r as Select,
  i as SelectPrimitive
};
